module.exports = __webpack_public_path__ + "img/google-chrome-web-store.b28d3ec0.svg";